import React from 'react';
import { HelpCircle } from 'lucide-react';
import { Text } from '@cotera/client/app/components/ui';
import type { WorkflowTriggerRenderStrategy } from '../types';

export const unknownTriggerStrategy: WorkflowTriggerRenderStrategy = {
  triggerKind: 'unknown',
  accent: 'neutral',
  badge: 'Trigger',
  matches: () => true,
  getTitle: (trigger) => {
    const name = trigger.kind === 'unknown' ? trigger.name : trigger.name;
    return name !== undefined && name.trim() !== '' ? name : 'Trigger';
  },
  getDescription: (trigger) =>
    trigger.kind === 'unknown' && trigger.rawKind !== undefined
      ? `Type: ${trigger.rawKind}`
      : 'Unsupported trigger type',
  renderIcon: () => <HelpCircle className="h-4 w-4" />,
  renderBody: (_trigger) => (
    <Text.Caption className="text-muted-foreground block">
      No renderer registered for this trigger.
    </Text.Caption>
  ),
};
